export default __webpack_public_path__ + "static/economy4-ff3ace911b184e5be9e95df602216643.png";